import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService, MenuItem } from "primeng/api";
import { CategoryService } from "../../../../services/categories.service";
import { Category } from "../../../../models/category";
import { MessageService } from "primeng/api";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { NgxSpinnerService } from "ngx-spinner";
import {
  PARAM_CATEGORIES_PATH,
} from "../../../constants/constants";

import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";

@Component({
    selector: "app-manage-categories",
    templateUrl: "./manage-categories.component.html",
    imports: [ButtonModule, ConfirmDialogModule, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, RouterLink, TableModule, TagModule, ToastModule]
})
export class ManageCategoriesComponent implements OnInit {
  categories: Category[] = [];
  category: Category;

  filterSidebar: boolean;
  error: string;
  comuni: any = [];
  cols: any[];
  exportColumns: any[];
  _selectedColumns: any[];
  loading: boolean;
  totalRecords: string;
  currentUser: any;
  page = 1;
  count = 0;
  pageSize = 10;
  pageSizes = [5, 10, 15];
  public base_path: string;
  basePath: string;
  pageOfItems: Array<any>;
  searchWrapper: boolean = false;
  nameFilter: string;
  descriptionFilter: string;
  codeFilter: string;
  codeIntFilter: string;
  brandFilter: string;

  productDialog: boolean = false;

  showDialog() {
    this.productDialog = true;
  }

  trackByFn(index, item) {
    return item.id;
  }

  constructor(
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private categoryService: CategoryService,
    private confirmationService: ConfirmationService
  ) {
    const doc = new jsPDF();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    const userId = this.currentUser.user_id;

    this.spinner.show();
    this.load();

    this.cols = [
      { field: "page_title", header: "Featured" },
      { field: "category_name", header: "Nome" },
      { field: "subpages", header: "Seo URL" },
      { field: "subpages", header: "Attivo" },
    ];

    this._selectedColumns = this.cols;
    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));
    this.spinner.hide();
  }

  getRequestParams(searchTitle, categoryTitle, page, pageSize): any {
    // tslint:disable-next-line:prefer-const
    let path = PARAM_CATEGORIES_PATH;
    const params = {};
    let adder = "?";
    if (page) {
      params[`page`] = page - 1;
      path += adder + "page=" + (page - 1);
      adder = "&";
    }
    if (searchTitle) {
      params[`category_name`] = searchTitle;
      path += adder + "category_name=" + searchTitle;
      adder = "&";
    }
    if (categoryTitle) {
      params[`category_description`] = categoryTitle;
      path += adder + "category_description=" + categoryTitle;
      adder = "&";
    }

    if (pageSize) {
      params[`size`] = pageSize;
      path += adder + "size=" + pageSize;
    }
    window.history.replaceState({}, "", path);

    return params;
  }

  reset(): void {
    this.nameFilter = "";
    this.descriptionFilter = "";
    this.codeFilter = "";
    this.codeIntFilter = "";
    this.brandFilter = "";
    this.load();
  }

  load(): void {
    const params = this.getRequestParams(
      this.nameFilter,
      this.descriptionFilter,
      this.page,
      this.pageSize
    );
    this.categoryService.list(params).subscribe((pData) => {
      this.categories = pData;
      this.count = this.categoryService.size;
    });
  }

  public handlePageChange(event): void {
    this.page = event;
    this.load();
  }

  public selectionItemForFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.cols = [];
    this.cols = colsTempor;
    if (e.value.length > 10) {
      e.value.pop();
    }
  }

  hideDialog() {
    this.productDialog = false;
  }

  onDelete(id: number, title: string) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.categoryService.delete(+id).subscribe(
          (res) => {
            console.log(res);
            this.ngOnInit();
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
          },
          (error) => {
            this.error = error;
            this.messageService.add({
              key: "myKey2",
              severity: "warn",
              summary: "Attenzione",
              detail: "Errore backend",
            });
          }
        );
      },
    });
  }
}
